import { phone } from 'phone';

export const validatePhone = (phoneNumber = '') => {
  const res = phone(phoneNumber);
  return res.isValid;
};
